import produce from 'immer';

export const getLocalCartWithProducts = (products, localCart) => {
  const addedProducts = produce(localCart, localCartDraft => {
    localCartDraft.map((cartItem, index) => {
      const foundIndex = products.findIndex(
        x => parseInt(x.id) === parseInt(cartItem.product_id)
      );

      if (cartItem.giftCard) {
        return cartItem;
      }

      if (foundIndex >= 0) {
        return (cartItem.product = products[foundIndex]);
      } else {
        return localCartDraft.splice(index, 1);
      }
    });
  });

  return addedProducts;
};

export const getSubtotalItems = cartProducts => {
  let total = 0;
  cartProducts.map(cartProduct => {
    if (cartProduct.product) {
      total += cartProduct.quantity * cartProduct.product.price;
    }

    if (cartProduct.giftCard) {
      total += parseInt(cartProduct.giftCard.original_balance);
    }
  });

  return total;
};

export const getHomeAssemblyTotal = cartProducts => {
  let total = 0;
  cartProducts.map(cartProduct => {
    if (cartProduct.shippingService) {
      total += cartProduct.shippingService.price * cartProduct.quantity;
      return;
    }
    if (cartProduct.shipping_service_id) {
      total += cartProduct.shippingServicePrice * cartProduct.quantity;
    }
  });

  return total;
};

export const getTotal = cartProducts => {
  let total = 0;
  cartProducts.map(cartProduct => {
    if (cartProduct.product) {
      total += cartProduct.quantity * cartProduct.product.price;
    }

    if (cartProduct.giftCard) {
      total += parseInt(cartProduct.giftCard.original_balance);
    }

    if (cartProduct.extend_plan) {
      total += (cartProduct.extend_plan.price * cartProduct.quantity) / 100;
    }

    if (cartProduct.shippingService) {
      total += cartProduct.shippingService.price * cartProduct.quantity;
      return;
    }
    if (cartProduct.shipping_service_id) {
      total += cartProduct.shippingServicePrice * cartProduct.quantity;
    }
  });

  return total;
};

export const getProductSku = data => {
  if (!data) return null;
  const cartSku = data.find(x => x.product && x.product.is_swatch != 1);
  return cartSku ? cartSku.product.sku : null;
};

export const arrayMove = (arr, fromIndex, toIndex) => {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};
